module.exports = __webpack_public_path__ + "media/images/athletes/1905-ef4b0777368cadefde9c341697c93aaa.png";